/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {editChild, getChild, getPriceList} from '../../../api/modules/order'
import {
  getProductName,
  getSalesArea,
  getEndUser,
  getSector,
  getIncoterm,
  getProvince,
  getCity,
  getPlant,
  getPayment,
  getProductType,
} from '../../../api/modules/getdatalist'
import Country from '../component/DataCountry.json'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import CustomUseEffect from './CustomUseEffect'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'

import {useTranslation, initReactI18next} from 'react-i18next'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import InputGroup from 'react-bootstrap/InputGroup'

import axios from 'axios'

const OrderEdit: React.FC = () => {
  const intl = useIntl()

  const [showEdit, setShowEdit] = useState(false)
  const {t} = useTranslation()

  const navigate = useNavigate()

  const [order, setOrder] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [retailFlag, setRetailFlag] = useState(false)

  //#region
  const [fullDetail, setFullDetail] = useState({
    produsen: '',
    enduser: '',
    enduser2: '',
    idSektor: '',
    sektor: '',
    incoterm1: '',
    incoterm11: '',
    incoterm2: '',
    incoterm22: '',
    country: '',
    country1: '',
    province: '',
    province1: '',
    city: '',
    city1: '',
    warehouse: '',
    warehouse2: '',
    ptype: '',
    pname: '',
    pnumber: '',
    punit: '',
    pspec: '',
    subprice: '',
    quantum: '',
    note: '',
    pay1: '',
    pay11: '',
    pay2: '',
    pay22: '',
  })

  const [filledOrder, setFilledOrder] = useState({
    sales_org_code: '',
    end_user: '',
    sector_id: '',
    incoterm1_id: '',
    incoterm2_id: '',
    province_id: '',
    region_id: '',
    city_id: '',
    plant: '',
    plant_desc: '',
    material_number: '',
    product_type: '',
    product_name: '',
    product_spec: '',
    request_price: '',
    request_quantum: '',
    payment_type_1: '',
    payment_type_2: '',
    notes: '',
  })
  const [produsen, setProdusen] = useState('')
  const [enduser, setEnduser] = useState('')
  const [enduser2, setEnduser2] = useState('')
  const [sektor, setSektor] = useState('')
  const [sektorDesc, setSektorDesc] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [incoterm1, setIncoterm1] = useState(0)
  const [incoterm11, setIncoterm11] = useState('')
  const [incoterm1Desc, setIncoterm1Desc] = useState(0)
  const [incoterm2, setIncoterm2] = useState(0)
  const [incoterm22, setIncoterm22] = useState('')
  const [incoterm2Desc, setIncoterm2Desc] = useState(0)
  const [province, setProvince] = useState(0)
  const [province1, setProvince1] = useState('')
  const [provinceDesc, setProvinceDesc] = useState('')
  const [country, setCountry] = useState(0)
  const [city, setCity] = useState(0)
  const [city1, setCity1] = useState('')
  const [warehouse, setWarehouse] = useState('test')
  const [warehouseDesc, setWarehouseDesc] = useState('test')
  const [ptype, setPtype] = useState('')
  const [ptype2, setPtype2] = useState('')
  const [pname, setPname] = useState('')
  const [pnumber, setPnumber] = useState('')
  const [punit, setPunit]= useState('')
  const [pspec, setPspec] = useState('')
  const [subprice, setSubprice] = useState(0)
  const [quantum, setQuantum] = useState(0)
  const [note, setNote] = useState('')
  const [pay1, setPay1] = useState('')
  const [pay11, setPay11] = useState('')
  const [pay2, setPay2] = useState('')
  const [pay22, setPay22] = useState('')
  const [disctribution, setDistribution] = useState('')
  const [plantSelected, setPlantSelected] = useState(false)

  const [cityDesc, setCityDesc] = useState(0)

  const [salesArea, setSalesArea] = useState<any[]>([])
  const [fullEndUser, setFullEndUser] = useState<any[]>([])
  const [fullSector, setFullSector] = useState<any[]>([])
  const [fullIncoterm, setFullIncoterm] = useState<any[]>([])
  const [fullProvince, setFullProvince] = useState<any[]>([])
  const [fullCity, setFullCity] = useState([])
  const [fullPlant, setFullPlant] = useState([])
  const [fullPayment, setFullPayment] = useState([])
  const [fullProductType, setFullProductType] = useState([])
  const [fullProductName, setFullProductName] = useState([])
  const [index, setIndex] = useState('')
  //#endregion

  const separateValue = (state: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
  }

  const separateValue2 = (state: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    state(parseInt(temp[0]))
    desc(temp[1])
  }

  const getSectorDesc = (id: any, value: any, desc: any) => {
    const temp = value.split('~#~')
    id(temp[0])
    desc(temp[2])
  }

  // const reloadData = async () => {
  //     const cred = localStorage.getItem("cust-code");
  //     try {
  //         await getEndUser(cred).then(
  //             (res) => {
  //                 console.log(res.data, " end user")
  //                 setFullEndUser(res.data.data);

  //             }
  //         )
  //     } catch {
  //         alert("error di enduser")
  //     }

  //     try {
  //         await getSector().then(
  //             (res) => {
  //                 console.log(res.data, " sector")
  //                 setFullSector(res.data.data)
  //             }
  //         )
  //     } catch {
  //         alert("error di sector")
  //     }

  //     try {
  //         await getProvince().then(
  //             (res) => {
  //                 console.log(res.data, " prov")
  //                 setFullProvince(res.data.data)
  //             }
  //         )
  //     } catch {
  //         alert("error di province")
  //     }

  //     try {
  //         await getIncoterm().then(
  //             (res) => {
  //                 console.log(res.data, " incoterm")
  //                 setFullIncoterm(res.data.data);
  //             }
  //         )
  //     } catch {
  //         alert("error di incoterm")
  //     }

  //     try {
  //         await getProductType().then(
  //             (res) => {
  //                 console.log(res.data, " product type")
  //                 setFullProductType(res.data.data);
  //             }
  //         )
  //     } catch {
  //         alert("error di product type")
  //     }

  //     paymentData();
  //     plantData()

  //     setLoading(false)
  // }

  const paymentData = async () => {
    await getPayment(localStorage.getItem('cust-code'), produsen).then((res) => {
      setFullPayment(res.data.data)
    })
  }

  const plantData = async () => {
    let temp: string[] = []
    if (sektor != '') {
      temp = sektor.split('~#~')
    }
    await getPlant(produsen, disctribution).then((res) => {
      setFullPlant(res.data.data)
    })
  }

  const plantChange = (value: any) => {
    const tempName = value.split('~#~')
    setWarehouse(tempName[0])
    setWarehouseDesc(tempName[1])
  }

  const productTypeChange = (value: any) => {
    const tempType = value.split('~#~')
    setPtype(tempType[1])
    setPtype2(tempType[0])
  }

  const productNameChange = (value: any) => {
    const tempName = value.split('~#~')
    setPname(tempName[1])
    setPnumber(tempName[0])
    setPunit(tempName[2])
  }

  const cityData = async (value: any) => {
    const tempName = value.split('~#~')
    setProvince(parseInt(tempName[0]))
    setProvinceDesc(tempName[1])
    try {
      await getCity(tempName[0]).then((res) => {
        setFullCity(res.data.data)
      })
    } catch {
      swal({
        title: `${t('errorDiCity')}`,
        icon: 'error',
      })
    }
  }

  const editOrder = async (index: any) => {
    const temp = {
      sales_org_code: produsen,
      end_user: enduser,
      sector_id: idSektor,
      incoterm1_id: incoterm1,
      incoterm2_id: incoterm2,
      province_id: province,
      region_id: country,
      city_id: city,
      plant: warehouse,
      plant_desc: warehouseDesc,
      material_number: pnumber,
      unit: punit,
      product_type: ptype,
      product_type_desc: ptype2,
      product_name: pname,
      product_spec: pspec,
      request_price: subprice,
      request_quantum: quantum,
      payment_type_1: pay1,
      payment_type_2: pay2,
      notes: note,
    }

    // await editChild(index, temp).then((res) => {
    //   console.log(res.data)
    //   swal({
    //     title: `${t('dataBerhasilDiedit')}`,
    //     icon: 'success',
    //   })
    //   setShowEdit(false)
    // })
  }

  useEffect(() => {
    const getEditDetail = async () => {
      setDistribution(localStorage.getItem('dist')!)
      setIndex(sessionStorage.getItem('id')!)
      try {
        await getChild(sessionStorage.getItem('id')!).then((res) => {
          setFullDetail({
            produsen: res.data.data.produsen?.name,
            enduser: res.data.data.end_user,
            enduser2: res.data.data.end_user?.name,
            idSektor: res.data.data.sector_id,
            sektor: res.data.data.sector?.name,
            incoterm1: res.data.data.incoterm1?.id,
            incoterm11: res.data.data.incoterm1?.code,
            incoterm2: res.data.data.incoterm2?.id,
            incoterm22: res.data.data.incoterm2?.code,
            province: res.data.data.province?.id,
            province1: res.data.data.province?.region_name,
            country: res.data.data.country,
            country1: res.data.data.country_desc,
            city: res.data.data.city?.id,
            city1: res.data.data.city?.city_name,
            warehouse: res.data.data.plant,
            warehouse2: res.data.data.plant_desc,
            ptype: res.data.data.product_type_desc,
            pname: res.data.data.product_name,
            pnumber: res.data.data.material_number,
            punit: res.data.data.unit,
            pspec: res.data.data.product_spec,
            subprice: res.data.data.request_price,
            quantum: res.data.data.request_quantum,
            note: res.data.data.notes,
            pay1: res.data.data.payment_type_1,
            pay11: res.data.data.payment_type_1_desc,
            pay2: res.data.data.payment_type_2,
            pay22: res.data.data.payment_type_2_desc,
          })

          setCountry(res.data.data.country)
          setProdusen(res.data.data.sales_org_code)
          setEnduser2(res.data.data.end_user)
          setEnduser(res.data.data.end_user)
          setIDSector(res.data.data.sector_id)
          setPnumber(res.data.data.material_number)
          setPunit(res.data.data.unit)
          setSektor(
            res.data.data.sector_distribution?.sector?.name +
              '(' +
              res.data.data.sector_distribution?.distribution_channel?.description +
              ')'
          )
          setIncoterm11(res.data.data.incoterm1?.code)
          setIncoterm1(res.data.data.incoterm1?.id)
          setIncoterm22(res.data.data.incoterm2?.code)
          setIncoterm2(res.data.data.incoterm2?.id)
          setProvince1(res.data.data.province?.region_name)
          setProvince(res.data.data.province?.id)
          setCity(res.data.data.city?.id)
          setCity1(res.data.data.city?.city_name)
          setWarehouse(res.data.data.plant)
          setPtype(res.data.data.product_type)
          setPname(res.data.data.product_name)
          setPspec(res.data.data.product_spec)
          setSubprice(res.data.data.request_price)
          setQuantum(res.data.data.request_quantum)
          setNote(res.data.data.notes)
          setPay1(res.data.data.payment_type_1)
          setPay11(res.data.data.payment_type_1_desc)
          setPay2(res.data.data.payment_type_2)
          setPay22(res.data.data.payment_type_2_desc)
        })
      } catch (e: any) {
        swal({
          title: `${e.message}`,
          icon: 'error',
        })
      }

      try {
        await getSalesArea(localStorage.getItem('cust-code')).then((res) => {
          setSalesArea(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiSalesArea')}`,
          icon: 'error',
        })
      }
    }

    getEditDetail()
  }, [])

  const priceListData = async () => {
    await getPriceList(localStorage.getItem('cust-code'), produsen, pnumber, city).then((res) => {
      setSubprice(res.data.data.price)
    })
  }

  CustomUseEffect(() => {
    if (retailFlag) priceListData()
    else return
  }, [produsen])

  CustomUseEffect(() => {
    if (retailFlag) priceListData()
    else return
  }, [pnumber])

  CustomUseEffect(() => {
    if (retailFlag) priceListData()
    else return
  }, [city])

  CustomUseEffect(() => {
    const getDrowdown = async () => {
      try {
        await getSalesArea(localStorage.getItem('cust-code')).then((res) => {
          setSalesArea(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiSalesArea')}`,
          icon: 'error',
        })
      }

      try {
        await getEndUser(localStorage.getItem('cust-code')).then((res) => {
          setFullEndUser(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiEnduser')}`,
          icon: 'error',
        })
      }

      try {
        await getSector(localStorage.getItem('dist')).then((res) => {
          setFullSector(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiSector')}`,
          icon: 'error',
        })
      }

      try {
        await getIncoterm().then((res) => {
          setFullIncoterm(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiIncoterm')}`,
          icon: 'error',
        })
      }

      try {
        await getProvince().then((res) => {
          setFullProvince(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiProvince')}`,
          icon: 'error',
        })
      }

      try {
        await getCity(fullDetail.province).then((res) => {
          setFullCity(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiCity')}`,
          icon: 'error',
        })
      }

      try {
        await getPlant(fullDetail.produsen, localStorage.getItem('dist')).then((res) => {
          setFullPlant(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiPlant')}`,
          icon: 'error',
        })
      }

      try {
        await getProductType('').then((res) => {
          setFullProductType(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiProductType')}`,
          icon: 'error',
        })
      }
      let tempsektor = ''
      if (idSektor != 0) tempsektor = String(idSektor)

      try {
        await getProductName(
          fullDetail.warehouse,
          localStorage.getItem('dist'),
          ptype,
          produsen,
          tempsektor
        ).then((res) => {
          setFullProductName(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiProductName')}`,
          icon: 'error',
        })
      }

      try {
        await getPayment(localStorage.getItem('cust-code'), fullDetail.produsen).then((res) => {
          setFullPayment(res.data.data)
        })
      } catch {
        swal({
          title: `${t('errorDiPayment')}`,
          icon: 'error',
        })
      }
    }
    getDrowdown()
  }, [fullDetail])

  CustomUseEffect(() => {
    let tempsektor = ''
    if (idSektor != 0) tempsektor = String(idSektor)
    const productNameData = async () => {
      await getProductName(warehouse, disctribution, ptype, produsen, tempsektor).then((res) => {
        setFullProductName(res.data.data)
      })
    }
    productNameData()
  }, [ptype2])

  CustomUseEffect(() => {
    const paymentData = async () => {
      await getPayment(localStorage.getItem('cust-code'), produsen).then((res) => {
        setFullPayment(res.data.data)
      })
    }

    paymentData()
  }, [produsen])

  CustomUseEffect(() => {
    plantData()
  }, [plantSelected, country])

  // CustomUseEffect(() => {
  //     reloadData()
  // }, [produsen])
  //#endregion

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: `${t('page Edit order')}`})}</PageTitle>
      {!loading ? (
        <div className='card p-5'>
          {/* begin::Header */}
          <div className='mb-8'>
            <p className='mt-5'>
              <i className='fw-normal'>
                {t('Order')}/
                <span className='text-primary fw-normal'>
                  {t('Edit')} {t('Order')}
                </span>
              </i>
            </p>
            <h1 className='fw-semibold'>
              {t('Edit')} {t('Order')}
            </h1>
          </div>

          <Row className='mb-5'>
            <Col sm={6}>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>Sales Org</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='produsen'
                  onChange={(e: any) => separateValue(setProdusen, e.target.value, setDistribution)}
                >
                  <option selected hidden disabled>
                    {fullDetail.produsen}
                  </option>
                  {salesArea.map((item: any, index: number) => {
                    return (
                      <option
                        key={item?.sales_org ?? index}
                        value={item.sales_org + '~#~' + item.distribution_channel}
                      >
                        {item.sales_org}
                      </option>
                    )
                  })}
                </Form.Select>
              </Form.Group>

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-endUser')}</Form.Label>
                <Form.Control
                  type='text'
                  id='spek'
                  placeholder={fullDetail.enduser}
                  onChange={(e: any) => setEnduser(e.target.value)}
                />
              </Form.Group>

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-sektor')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='sektor'
                  onChange={(e: any) => {
                    setSektor(e.target.value)
                    getSectorDesc(setIDSector, e.target.value, setSektorDesc)
                  }}
                >
                  <option selected hidden disabled>
                    {fullDetail.sektor}
                  </option>
                  {fullSector.map((item: any, index: number) => {
                    return (
                      <option key={item?.id ?? index} value={item.id + '~#~' + '' + '~#~' + item.name}>
                        {item.name}
                      </option>
                    )
                  })}
                </Form.Select>
              </Form.Group>

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-incoterm1')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='incoterm1'
                  onChange={(e: any) => separateValue2(setIncoterm1, e.target.value, setIncoterm1Desc)}
                >
                  <option selected hidden disabled>
                    {fullDetail.incoterm11}
                  </option>
                  {fullIncoterm.map((item: any, index: number) => {
                    return (
                      <option key={item?.id ?? index} value={item.id + '~#~' + item.code}>
                        {item.code}
                      </option>
                    )
                  })}
                </Form.Select>
              </Form.Group>

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-incoterm2')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='incoterm2'
                  onChange={(e: any) => separateValue2(setIncoterm2, e.target.value, setIncoterm2Desc)}
                >
                  <option selected hidden disabled>
                    {fullDetail.incoterm22}
                  </option>
                  <option value='0;0'></option>
                  {fullIncoterm.map((item: any, index: number) => {
                    return (
                      <option key={item?.id ?? index} value={item.id + '~#~' + item.code}>
                        {item.code}
                      </option>
                    )
                  })}
                </Form.Select>
              </Form.Group>

              {idSektor == 3 ? (
                <>
                  <Form.Group className='mb-5' controlId='formBasicEmail'>
                    <Form.Label>{t('sub-order-negara')}</Form.Label>
                    <Form.Select
                      aria-label='Default select example'
                      id='negara'
                      onChange={(e: any) => setCountry(parseInt(e.target.value))}
                    >
                      <option selected hidden disabled>
                        {fullDetail.country1}
                      </option>
                      {Country.dataCountry.map((item: any, index: number) => {
                        return (
                          <option key={item?.code ?? index} value={item.code}>
                            {item.name}
                          </option>
                        )
                      })}
                    </Form.Select>
                  </Form.Group>
                </>
              ) : (
                <>
                  <Form.Group className='mb-5' controlId='formBasicEmail'>
                    <Form.Label>{t('sub-order-provinsi')}</Form.Label>
                    <Form.Select
                      aria-label='Default select example'
                      id='provinsi'
                      onChange={(e: any) => cityData(e.target.value)}
                    >
                      <option selected hidden disabled>
                        {fullDetail.province1}
                      </option>
                      {fullProvince.map((item: any, index: number) => {
                        return (
                          <option key={item?.id ?? index} value={item.id + '~#~' + item.value}>
                            {item.value}
                          </option>
                        )
                      })}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className='mb-5' controlId='formBasicEmail'>
                    <Form.Label>{t('sub-order-kota')}</Form.Label>
                    <Form.Select
                      aria-label='Default select example'
                      id='kota'
                      onChange={(e: any) => {
                        separateValue2(setCity, e.target.value, setCityDesc)
                        setPlantSelected(true)
                      }}
                    >
                      <option selected disabled hidden>
                        {fullDetail.city1}
                      </option>
                      {fullCity.map((item: any, index: number) => {
                        return (
                          <option key={item?.id ?? index} value={item.id + '~#~' + item.value}>
                            {item.value}
                          </option>
                        )
                      })}
                    </Form.Select>
                  </Form.Group>
                </>
              )}

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-gudang')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='gudang'
                  placeholder={t('sub-order-gudang')}
                  onChange={(e: any) => plantChange(e.target.value)}
                >
                  <option disabled selected hidden>
                    {fullDetail.warehouse}
                  </option>
                  {fullPlant?.map((item: any, index: number) => {
                    return (
                      <option key={item?.plant ?? index} value={item.plant + '~#~' + item.plant_name}>
                        {item.plant} - {item.plant_name}
                      </option>
                    )
                  })}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-jenis')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='jenis'
                  onChange={(e: any) => productTypeChange(e.target.value)}
                >
                  <option disabled selected hidden>
                    {fullDetail.ptype}
                  </option>
                  {fullProductType.map((item: any, index: number) => {
                    return (
                      <option
                        key={item?.material_group ?? index}
                        value={item.material_group_desc + '~#~' + item.material_group}
                      >
                        {item.material_group} - {item.material_group_desc}
                      </option>
                    )
                  })}
                </Form.Select>
              </Form.Group>

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-produk')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='produk'
                  onChange={(e: any) => productNameChange(e.target.value)}
                >
                  <option selected hidden disabled>
                    {fullDetail.pname}
                  </option>
                  {fullProductName.map((item: any, index: number) => {
                    return (
                      <option
                        key={item?.material_number ?? index}
                        value={item.material_number + '~#~' + item.material_description}
                      >
                        {parseInt(item.material_number) + " - " + item.material_description}
                      </option>
                    )
                  })}
                </Form.Select>
              </Form.Group>

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-spek')}</Form.Label>
                <Form.Control
                  type='text'
                  as='textarea'
                  style={{height: '40px'}}
                  id='spek'
                  placeholder={fullDetail.pspec}
                  onChange={(e: any) => setPspec(e.target.value)}
                />
              </Form.Group>

              {idSektor == 2 ? (
                <Form.Group className='mb-5' controlId='formBasicEmail'>
                  <Form.Label>{t('Price')}</Form.Label>
                  <Form.Control
                    type='text'
                    value={'Rp' + fullDetail.subprice}
                    id='hargap'
                    disabled
                  />
                </Form.Group>
              ) : idSektor == 3 ? (
                <Form.Group className='mb-5' controlId='formBasicEmail'>
                  <Form.Label>{t('sub-order-hargaP')}</Form.Label>
                  <InputGroup size='sm'>
                    <InputGroup.Text>
                      <span className='px-2'>USD</span>
                    </InputGroup.Text>
                    <Form.Control
                      type='text'
                      placeholder={String(fullDetail.subprice)}
                      id='hargap'
                      onChange={(e: any) => setSubprice(parseInt(e.target.value))}
                    />
                  </InputGroup>
                </Form.Group>
              ) : (
                <Form.Group className='mb-5' controlId='formBasicEmail'>
                  <Form.Label>{t('sub-order-hargaP')}</Form.Label>
                  <InputGroup size='sm'>
                    <InputGroup.Text>
                      <span className='px-1'>Rp</span>
                    </InputGroup.Text>
                    <Form.Control
                      type='text'
                      placeholder={String(fullDetail.subprice)}
                      id='hargap'
                      onChange={(e: any) => setSubprice(parseInt(e.target.value))}
                    />
                  </InputGroup>
                </Form.Group>
              )}

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-kuantum')}</Form.Label>
                <Form.Control
                  type='text'
                  id='kuantum'
                  placeholder={String(fullDetail.quantum?.toLocaleString())}
                  onChange={(e: any) => setQuantum(parseInt(e.target.value))}
                />
              </Form.Group>

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-payment1')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='payment1'
                  onChange={(e: any) => setPay1(e.target.value)}
                >
                  <option selected hidden disabled>
                    {fullDetail.pay11}
                  </option>
                  {fullPayment.map((item: any) => {
                    return (
                      <option key={item?.payment_method} value={item.payment_method}>
                        {item.payment_desc}
                      </option>
                    )
                  })}
                </Form.Select>
              </Form.Group>

              <Form.Group className='mb-5' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-payment2')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='payment2'
                  onChange={(e: any) => setPay2(e.target.value)}
                >
                  <option selected disabled hidden>
                    {fullDetail.pay22}
                  </option>
                  {fullPayment.map((item: any) => {
                    return (
                      <option key={item?.payment_method} value={item.payment_method}>
                        {item.payment_desc}
                      </option>
                    )
                  })}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <div className='d-flex justify-content-end'>
            <Link to='/management/order/all' className='me-2'>
              <Button variant='secondary'>{t('order-kembali')}</Button>
            </Link>
            <Button variant='primary' className='fw-semibold' onClick={() => editOrder(index)}>
              {t('order-kirim')}
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <label>Loading...</label>
        </div>
      )}
    </>
  )
}

export {OrderEdit}
